import React from "react"
import Image from "../image"

class Banner extends React.Component {
  render() {
    return (
      <div className="banner">
        <div className="container is-slim">
          <div className="is-hidden-mobile">\n          </div>
          <div className="is-hidden-tablet">
          </div>
        </div>
      </div>
    )
  }
}

export default Banner
